export default __webpack_public_path__ + "static/lines+plus-be5c7fa4e8f74c82b32dae27c31acff3.svg";